import { render, staticRenderFns } from "./paiementModal.vue?vue&type=template&id=52d9382b&scoped=true&"
import script from "./paiementModal.vue?vue&type=script&lang=js&"
export * from "./paiementModal.vue?vue&type=script&lang=js&"
import style0 from "./paiementModal.vue?vue&type=style&index=0&id=52d9382b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9382b",
  null
  
)

export default component.exports